<template>
  <div class="menu-item py2 flex items-center pointer flex-auto" :class="{'menu-item-selected': selectedItem}" style="min-height:75px;" @click="goToItem()">
    <i class="block menu-item-icon" :class="icon"></i>
    <div class="menu-item-label xs-hide">{{ getReferencelabel(text) }}</div>
  </div>
</template>

<script>

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { getReferencelabel } from '@/mixins/utils';

export default {
  props: {
    icon: String,
    text: String,
    pathName: String,
    path: String
  },
  setup (props) {
    const route = useRoute();
    const router = useRouter();

    const selectedItem = computed(() => route.matched.length && route.matched[0].name === props.pathName);
    const selectedColor = computed(() => (props.selectedItem ? '#e81d00' : '#636d73'));

    function goToItem () {
      router.push({ name: props.pathName });
    }

    return { selectedItem, selectedColor, goToItem, getReferencelabel };
  }
};
</script>

<style>
.menu-item {
  height: 50px;
  border-top: 2px solid #00a6c6;
  font-weight: 600;
  font-size: 0.75rem;
  flex-direction: column;
  color: #636d73;
}

.menu-item:hover {
  background-color: #f5f5f5;
}

.menu-item-selected {
  color: #e81d00;
}

.menu-item-icon {
  font-size: 25px;
}

.menu-item-label {
  font-size: .75rem;
  text-transform:uppercase;
  margin-top: 0.3rem;
}

@media (min-width: 52em) {
  .menu-item {
    width: 100%;
    border-top: 0px;
    flex-direction: row;
    padding: 0rem 1rem;
  }

  .menu-item-label {
    font-size: .875rem;
  }

  .menu-item-icon {
    margin: 0 1rem;
  }
}
@media (max-width: 40em){

  .menu-item-icon {
    font-size: 30px;
  }

}

</style>
